import type { ReactNode } from "react";
import { AUTH_PROVIDER } from "./config";
import { Auth0ProviderWithNavigate } from "../auth0/auth";
import { ClerkProviderWithNavigate } from "../clerk/provider";

/**
 * Unified auth provider
 * Wraps children with Auth0 or Clerk based on toggle
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  if (AUTH_PROVIDER === "clerk") {
    return <ClerkProviderWithNavigate>{children}</ClerkProviderWithNavigate>;
  }
  return <Auth0ProviderWithNavigate>{children}</Auth0ProviderWithNavigate>;
}
